var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { flatten, head } from '../../../../../utils/helper/lodash_replacements';
import { isNumericString } from '../../../../../utils/helper/helper_string';
import { cloneJSON } from '../../../../../utils/helper/helper_object';
export class OrderedTaskOrders {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    /*
    get isValid(): boolean {
      return !this.flatCorrectOrders.map(o => o.includes(false)).includes(true);
    }
    */
    get longestCorrectOrderLength() {
        return Math.max(...this.flatCorrectOrders.map(order => order.length));
    }
    get nearestCorrectOrder() {
        return head(this.flatCorrectOrders.slice().sort((o1, o2) => this.scoreOrder(o2) - this.scoreOrder(o1)));
    }
    scoreOrder(order) {
        let matches = 0;
        this.task.orderedTaskEvaluate.latestSelectedOptionIndicies.forEach((optionIndex, arrayPosition) => {
            if (typeof optionIndex === 'number' && order[arrayPosition] === optionIndex) {
                matches++;
            }
        });
        return matches;
    }
    get flatCorrectOrders() {
        return flatten(this.completeOrders.map(completeOrder => this.flatForComplete(completeOrder)));
    }
    flatForComplete(completeOrder) {
        const flats = [[]];
        for (const step of completeOrder) {
            const oldFlats = cloneJSON(flats); // clone deep
            for (const k in step) {
                const stepAlt = step[k];
                if (k === '0') {
                    for (const flat of flats) {
                        flat.push(stepAlt);
                    }
                }
                else {
                    const addFlats = cloneJSON(oldFlats); // clone deep
                    for (const addFlat of addFlats) {
                        addFlat.push(stepAlt);
                    }
                    flats.push(...addFlats);
                }
            }
        }
        return flats;
    }
    get completeOrders() {
        return this.task.correctOrderString.split('||').map(s => this.ordersForCompleteString(s));
    }
    ordersForCompleteString(s) {
        const steps = s.split(',');
        return steps.map(step => this.ordersForStepString(step));
    }
    ordersForStepString(s) {
        return s.split('|').map(stepAlt => this.valueForStepAlt(stepAlt));
    }
    valueForStepAlt(s) {
        if (!s || !isNumericString(s) || parseInt(s) > this.task.options.length) {
            return false;
        }
        return parseInt(s) - 1;
    }
    get primaryCorrectIndexOrder() {
        const numbers = this.task.correctOrderString.split(',');
        if (numbers.length < 1)
            return;
        if (numbers.find(number => !number || !isNumericString(number) || parseInt(number) > this.task.options.length)) {
            return [];
        }
        const numbers2 = numbers.map(i => parseInt(i)).filter(n => n <= this.task.options.length);
        return numbers2.map(i => i - 1);
    }
}
__decorate([
    computed.struct
], OrderedTaskOrders.prototype, "nearestCorrectOrder", null);
__decorate([
    computed
], OrderedTaskOrders.prototype, "completeOrders", null);
__decorate([
    computed
], OrderedTaskOrders.prototype, "primaryCorrectIndexOrder", null);
